<template>
  <div class="app-footer">
    <div class="app-footer__inner">
      <div class="app-footer-left">
        Powered by AndamiCompany Mono-Arch © 2023
      </div>
      <div class="app-footer-right">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {
  }
}
</script>
